import { axiosInstance } from "@helpers/axios-instance";
import { DataAwareResponse } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

type HouseholdData = {
  data: string;
  id: string;
  objectId: string;
  type: string;
};

export function useHouseholdData(objectId: string | undefined, type: string) {
  return useQueryWithValidation({
    queryKey: ["householdData", String(objectId), type],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Household/Data/${type}/${objectId}`,
      });
      return data.data as DataAwareResponse<HouseholdData>;
    },
  });
}
